import { Loader2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ModelSelectorLoadingProps {
  className?: string
}

export const ModelSelectorLoading = ({ className }: ModelSelectorLoadingProps): ReactNode => {
  return (
    <div
      className={cn(
        'model-selector-loading flex h-9 items-center gap-2 rounded-md border px-3 py-2',
        className
      )}
    >
      <Loader2Icon className="size-4 animate-spin" />
      <span className="text-sm text-muted-foreground">Loading models...</span>
    </div>
  )
}

ModelSelectorLoading.displayName = 'ModelSelectorLoading'
